module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.4786/images/default-avatar.png"